"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionRestrictionPoint_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionArea_1 = require("./PermissionArea");
var PermissionElementBehaviour_1 = require("./PermissionElementBehaviour");
var PermissionGroupDefaults_1 = require("./PermissionGroupDefaults");
var PermissionUserOverrides_1 = require("./PermissionUserOverrides");
var PermissionRestrictionPoint_Factory = /** @class */ (function () {
    function PermissionRestrictionPoint_Factory() {
    }
    PermissionRestrictionPoint_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PermissionArea: PermissionArea_1.PermissionArea_Factory.CreateIncoming(model.PermissionArea),
            PermissionAreaId: model.PermissionAreaId,
            PermissionElementBehaviours: model.PermissionElementBehaviours && model.PermissionElementBehaviours.map(function (i) { return PermissionElementBehaviour_1.PermissionElementBehaviour_Factory.CreateIncoming(i); }),
            PermissionGroupDefaults: model.PermissionGroupDefaults && model.PermissionGroupDefaults.map(function (i) { return PermissionGroupDefaults_1.PermissionGroupDefaults_Factory.CreateIncoming(i); }),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            PermissionUserOverrides: model.PermissionUserOverrides && model.PermissionUserOverrides.map(function (i) { return PermissionUserOverrides_1.PermissionUserOverrides_Factory.CreateIncoming(i); }),
            RestrictedToFeature: model.RestrictedToFeature,
            RestrictionType: model.RestrictionType,
            SortPosition: model.SortPosition,
        };
        return result;
    };
    PermissionRestrictionPoint_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            PermissionArea: PermissionArea_1.PermissionArea_Factory.CreateOutgoing(model.PermissionArea),
            PermissionAreaId: model.PermissionAreaId,
            PermissionElementBehaviours: model.PermissionElementBehaviours && model.PermissionElementBehaviours.map(function (i) { return PermissionElementBehaviour_1.PermissionElementBehaviour_Factory.CreateOutgoing(i); }),
            PermissionGroupDefaults: model.PermissionGroupDefaults && model.PermissionGroupDefaults.map(function (i) { return PermissionGroupDefaults_1.PermissionGroupDefaults_Factory.CreateOutgoing(i); }),
            PermissionRestrictionPointId: model.PermissionRestrictionPointId,
            PermissionUserOverrides: model.PermissionUserOverrides && model.PermissionUserOverrides.map(function (i) { return PermissionUserOverrides_1.PermissionUserOverrides_Factory.CreateOutgoing(i); }),
            RestrictedToFeature: model.RestrictedToFeature,
            RestrictionType: model.RestrictionType,
            SortPosition: model.SortPosition,
        };
        return result;
    };
    return PermissionRestrictionPoint_Factory;
}());
exports.PermissionRestrictionPoint_Factory = PermissionRestrictionPoint_Factory;
